<template>
  <div
    class="exchange-result"
    :class="{
      'pad-exchange-result': isMGAppInPad,
      'h5-exchange-result': isH5 && !isMGAppInPad,
      'pc-exchange-result': !isH5 && !isMGAppInPad,
      'electron-exchange-result': isElectron,
    }"
  >
    <p class="page-title" v-if="!isHXApp">
      <img
        @click="jumpExchange"
        class="back"
        src="../../assets/images/back-icon.png"
        alt=""
      />
      课程兑换
    </p>
    <div class="cont-wrap">
      <p class="status-wrap">
        <img src="../../assets/images/dui-icon.png" alt="" />兑换成功！
      </p>
      <div class="course-card">
        <img
          class="cover"
          :src="handleImageUrl(courseInfo.cover_url) + '?imageView2/0/w/300'"
          alt=""
        />
        <p class="title">{{ courseInfo.course_name }}</p>
      </div>
      <div class="operate-wrap">
        <button class="cancel-btn" @click="jumpExchange">继续兑换</button>
        <button @click="jumpStudy" class="go-study">去学习</button>
      </div>
    </div>
  </div>
</template>

<script>
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import { isHXApp, isH5, isMGAppInPad, handleImageUrl } from "@saas/components";
export default {
  props: {
    courseInfo: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      isHXApp: isHXApp(),
      isMGAppInPad: isMGAppInPad(),
      isH5: isH5(),
      handleImageUrl,
      isElectron: window.isElectron,
    };
  },
  methods: {
    jumpExchange() {
      this.$emit("jumpExchange");
    },
    jumpStudy() {
      if (this.isHXApp) {
        let params = {
          courseId: this.courseInfo.id,
        };
        let otherData = {
          name: "myCourseDetail",
        };
        jsToFlutter("openPage", params, otherData);
      } else {
        this.$router.push({
          name: "myCourseDetail",
          params: { id: this.courseInfo.id },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.h5-exchange-result {
  height: 100vh;
  background: #fff;
  .page-title {
    display: flex;
    align-items: center;
    height: 1.2rem;
    justify-content: center;
    position: relative;
    font-weight: 500;
    font-size: 0.43rem;
    color: #0d1400;
    line-height: 0.59rem;
    .back {
      position: absolute;
      left: 0.45rem;
      top: 50%;
      transform: translateY(-50%);
      width: 0.4rem;
      height: 0.4rem;
    }
  }

  .cont-wrap {
    padding-top: 0.8rem;
    width: 8.72rem;
    margin: 0 auto;
  }
  .status-wrap {
    justify-content: center;
    display: flex;
    align-items: center;
    img {
      width: 0.64rem;
      height: 0.64rem;
      margin-right: 0.21rem;
    }
    font-weight: 500;
    font-size: 0.43rem;
    color: #0d1400;
    line-height: 0.59rem;
    margin-bottom: 0.72rem;
  }
  .course-card {
    width: 8.72rem;
    height: 2.88rem;
    border-radius: 0.32rem;
    border: 0.01rem solid #efefef;
    display: flex;
    margin-bottom: 0.99rem;
    padding: 0.32rem 0.24rem 0.32rem 0.32rem;
    .cover {
      border-radius: 0.24rem;
      width: 4rem;
      height: 2.24rem;
      margin-right: 0.27rem;
      object-fit: cover;
    }
    .title {
      flex: 1;
      width: 0;
      font-weight: 500;
      font-size: 0.43rem;
      color: #0d1400;
      line-height: 0.59rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
    }
  }
  .operate-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .cancel-btn,
  .go-study {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 4.16rem;
    height: 1.28rem;
    font-size: 0.43rem;
    border-radius: 0.64rem;
    line-height: 0.43rem;
  }
  .cancel-btn {
    border: 0.01rem solid #aeefe1;
    color: #00c89d;
  }
  .go-study {
    color: #fff;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
  }
}

.pad-exchange-result,
.pc-exchange-result {
  min-height: calc(100vh - #{$nav-bar-height} - #{$nav-footer-height});
  background: #fff;
  .page-title {
    display: none;
  }
  .cont-wrap {
    padding-top: 40px;
    width: 375px;
    margin: 0 auto;
  }
  .status-wrap {
    justify-content: center;
    display: flex;
    align-items: center;
    img {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
    font-weight: 500;
    font-size: 16px;
    color: #0d1400;
    line-height: 22px;
    margin-bottom: 30px;
  }
  .course-card {
    width: 327px;
    margin: 0 auto;
    height: 108px;
    border-radius: 12px;
    border: 1px solid #efefef;
    display: flex;
    // align-items: center;
    margin-bottom: 40px;
    padding: 12px 9px 12px 12px;
    .cover {
      border-radius: 9px;
      width: 150px;
      height: 84px;
      margin-right: 10px;
      object-fit: cover;
    }
    .title {
      flex: 1;
      width: 0;
      font-weight: 500;
      font-size: 16px;
      color: #0d1400;
      line-height: 22px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
    }
  }
  .operate-wrap {
    width: 327px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .cancel-btn,
  .go-study {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 158px;
    height: 50px;
    font-size: 16px;
    border-radius: 25px;
    line-height: 16px;
  }
  .cancel-btn {
    border: 1px solid #aeefe1;
    color: #00c89d;
  }
  .go-study {
    color: #fff;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
  }
}
.electron-exchange-result {
  min-height: calc(100vh - #{$top-bar-height});
}
</style>
